import Column from '@components/Column';
import Skeleton from '@components/Skeleton';
import styled from '@emotion/styled';

interface Props {
    count?: number;
}

function OrderLogSkeletons({ count = 3 }: Props) {
    return (
        <List fullWidth aria-busy>
            {Array.from({ length: count }).map((_, idx) => (
                <Card key={`order-log-sk-${idx}`} fullWidth>
                    <Body fullWidth spacing={3}>
                        <Skeleton width={48} height={22} />
                        <Skeleton width='40%' height={22} />
                        <Skeleton width='80%' height={20} />
                    </Body>
                    <Footer>
                        <Skeleton width={80} height={20} />
                    </Footer>
                </Card>
            ))}
        </List>
    );
}

const List = styled(Column)`
    row-gap: 18px;
`;

const Card = styled(Column)`
    background-color: var(--color-white);
    border: 1px solid var(--color-border-default);
    border-radius: var(--radius-sm);
    overflow: hidden;
`;

const Body = styled(Column)`
    padding: var(--spacing-4);
`;

const Footer = styled.div`
    border-top: 1px solid var(--color-border-default);
    display: flex;
    justify-content: center;
    padding: var(--spacing-2) 0;
    width: 100%;
`;

export default OrderLogSkeletons;
